import React from 'react';
import {
  Modal,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Post } from 'lib/types/posts';
import { TimeSeriesDataPoint } from 'server/api/services/analytics/types';
import { NETWORKS } from 'lib/constants';
import { StatsOverTime } from 'features/Analytics/Charts/StatsOverTime';

interface SparklinesModalProps {
  open: boolean;
  onClose: () => void;
  dailyStats: TimeSeriesDataPoint[];
  post: Post;
}

export const SparklinesModal = ({
  open,
  onClose,
  dailyStats,
  post,
}: SparklinesModalProps) => {
  // Add current post stats to daily stats if needed
  const today = new Date().toISOString().split('T')[0];
  const hasTodayStats = dailyStats.some((stat) => stat.date === today);

  let statsToUse = dailyStats;
  if (!hasTodayStats) {
    const currentStats: TimeSeriesDataPoint = {
      date: today,
      views: post.currentCombinedViews,
      combinedViews: post.currentCombinedViews,
      plays: post.currentPlays,
      likes: post.currentLikes,
      shares: post.currentShares,
      comments: post.currentComments,
      impressions: post.currentImpressions,
      count: 1,
    };
    statsToUse = [...dailyStats, currentStats];
  }

  // Sort by date string to avoid timezone conversion issues
  const sortedStats = statsToUse.sort(
    (a, b) => a.date.localeCompare(b.date),
  );

  const postedAtDate = post.postedAt ? `(posted ${new Date(post.postedAt).toLocaleDateString()})` : '';
  const networkName = NETWORKS[post.network]?.title || '';

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="sparklines-modal"
    >
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-[800px] bg-white shadow-lg p-8 rounded-lg max-h-[90vh] overflow-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">
            {networkName}
            {' '}
            Performance
            {' '}
            {postedAtDate}
          </h2>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </div>

        <div className="h-[400px]">
          <StatsOverTime
            data={sortedStats}
            title={`${networkName} Performance Over Time`}
            subtitle=""
            defaultStat="likes"
          />
        </div>
      </div>
    </Modal>
  );
};
